module.exports = __webpack_public_path__ + "img/quanjinditu.5f37e67e.png";